import { WaitlistPage } from "./WaitlistPage"
import { getCropWaitlistCsv, useCropWaitlist, useDeleteCropWaitlistSignup } from "@/hooks/useComms"

export function CropWaitlist() {
  return (
    <WaitlistPage
      title="Crop beta waitlist"
      purpose="Crop beta access"
      product="Crop"
      csvPrefix="crop-waitlist"
      listName="the Crop beta waitlist"
      useList={useCropWaitlist}
      getCsv={getCropWaitlistCsv}
      useDelete={useDeleteCropWaitlistSignup}
    />
  )
}
